import React from 'react'
import InstagramFeed from './InstagramFeed'
import { getImages } from '../../Common/const';
import UseScrollReveal from '../../Common/UseScrollReveal';

const JoinEec = () => {
    UseScrollReveal();
    return (
        <>
            <section className='join-eec-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6 jeec-left pe-md-5'>
                            <InstagramFeed/>
                        </div>
                        <div className='col-md-6 jeec-right d-flex'>
                            <div className='w-100'>
                                <div className='mb-5 pb-md-4 join-eec-logo'>
                                    <img src={getImages('eec-logo-white.png')} alt='European Exotic Center' />
                                </div>
                                <div className="lg-title font-2-5em reveal wow fadeIn">Join the European Exotic <br/>Center Community</div>
                                <div className='sm-title mb-1 reveal wow fadeIn'>Follow us on Instagram</div>
                                <div className='md-title mb-4 reveal text-orange wow fadeIn'>@europeanexoticcenter</div>
                                <div className='mt-80 reveal wow fadeIn'>
                                    <a href='https://www.instagram.com/europeanexoticcenter' target='_blank' className='black-red-btn w-240 text-uppercase d-inline-block'>Follow Us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default JoinEec